import React, { Component } from 'react';
import { Button} from '@material-ui/core';
import PropTypes from 'prop-types';

class SimpleDialogFragment extends Component {
  render() {
    const { title, buttonLabel, onClick } = this.props;
    return (
      <div>
        <span>
          <h3>
            {title}
          </h3>
        </span>
        <br />
        <Button onClick={onClick} className="ssenseButton ssenseDefault">{buttonLabel}</Button>
      </div>
    )
  }
}

SimpleDialogFragment.propTypes = {
  title: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

export default SimpleDialogFragment;